export const GET_CHANNEL_LIST = 'getChannelList';
export const GET_BRANCH_LIST = 'getBranchList';
export const GET_TERMINAL_LIST = 'getTerminalList';
